<template>
  <div>
    <el-form
      @submit.native.prevent="onSubmitInepMatricula"
      :model="form"
      ref="formTransporte"
      label-position="top"   >
     
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Inep da Matrícula" prop="inep" >
            <el-input v-model="form.inep" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24">
          <el-form-item class="u-text-right u-mt-15">
            <el-button type="primary" native-type="submit">SALVAR</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ["matricula"],
  data: () => ({
    form: {
      inep: ''
    }
  }),
  mounted() {
    
  },
  methods: {   
    onSubmitInepMatricula() {
      this.$refs.formTransporte.validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              `${this.$store.state.config.baseUrlApi}/api/matricula/updateInepMatricula/` +
                this.matricula.id,
              { inep: this.form.inep },
              this.$store.getters.getHeaderAuth
            )
            .then((response) => {
              if (typeof response.data.throw !== "undefined") {
                window.eventBus.$emit("alert", {
                  msg: response.data.throw.msg,
                  type: response.data.throw.type,
                });
              } else {
                window.eventBus.$emit("alert", {
                  msg: "Sucesso! - Operação realizada com Sucesso!",
                  type: "success",
                });
                this.dialogInepMatricula = false;
                this.$emit("onSubmitInepMatricula");
              }

              window.eventBus.$emit("loading", false);
            })
            .catch((error) => {
              window.eventBus.$emit("loading", false);
              this.$store.commit("throwException", error);
            });
        } else {
          window.eventBus.$emit("alert", {
            msg: "Campos obrigatórios não foram preenchidos.",
            type: "warning",
          });
        }
      });
    },
  },
  watch: {},
  components: {},
};
</script>